import type { ProductHistory } from "../../types/sales";

interface Props {
  product: ProductHistory;
}

export const ExpandableProductRow: React.FC<Props> = ({ product }) => {
  return (
    <tr>
      <td colSpan={7} className="p-4 space-y-6">
        {/* SALES RECORDS */}
        <div>
          <h4 className="font-semibold mb-2">Sales Records</h4>

          <div className="overflow-x-auto border rounded-md">
            <table className="w-full text-sm">
              <thead className="bg-blue-200 text-primary">
                <tr>
                  <th className="py-2 px-3">Date</th>
                  <th>Qty</th>
                  <th>Total Cost</th>
                  <th>Unit Price</th>
                  <th>Total Price (Sold at)</th>
                  <th>Profit</th>
                </tr>
              </thead>
              {
                product.sales.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="py-6 text-center text-gray-500">
                      No sales recorded for this product
                    </td>
                  </tr>
                ) : (
                  <tbody>
                    {product.sales.map((sale, idx) => (
                      <tr key={idx} className="border-t">
                        <td className="px-3 py-2">{sale.date}</td>
                        <td>{sale.quantity}</td>
                        <td>GHS {sale.cost}</td>
                        <td>GHS {sale.sellingPrice}</td>
                        <td className="font-bold text-primary">GHS {sale.revenue}</td>
                        <td className="text-green-700">
                          GHS {(sale.revenue - sale.cost).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )
              }
            </table>
          </div>
        </div>

        {/* INVENTORY RECORDS */}
        <div>
          <h4 className="font-semibold mb-2">Inventory History</h4>

          <div className="overflow-x-auto border rounded-md">
            <table className="w-full text-sm">
              <thead className="bg-blue-200 text-primary">
                <tr>
                  <th className="py-2 px-3">Batch</th>
                  <th>Added</th>
                  <th>Expiry</th>
                  <th>Restocked</th>
                </tr>
              </thead>
              {
                product.inventory.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="py-6 text-center text-gray-500">
                      No inventory records for this product
                    </td>
                  </tr>
                ) : (
                  <tbody>
                    {product.inventory.map((batch) => (
                      <tr key={batch.batchId} className="border-t">
                        <td className="px-3 py-2">{`${batch.batchId.slice(0, 13)}...`}</td>
                        <td>{batch.quantityAdded}</td>
                        <td>{batch.expiryDate}</td>
                        <td>{batch.restockedAt}</td>
                      </tr>
                    ))}
                  </tbody>
                )
              }
            </table>
          </div>
        </div>
      </td>
    </tr>
  );
};
